module.exports = __webpack_public_path__ + "static/media/flexipaybill_hor_white.121457a9.svg";